import React from 'react';

import BaseIcon from '../BaseIcon';

export const Notice = (props) => (
    <BaseIcon {...props} viewBox="0 0 65.1968536 65.1968536">
        <path
            d="M62.261013,1.443469c0,3.5290694,0.0537949,62.4996338,0.0537949,62.4996338
            c0,0.8358269-0.4565773,1.2537498-1.3670425,1.2537498c-0.7542305,0-16.3599777-0.0284729-17.1761627-0.0284729
            c-0.5656738,0-24.9255104-35.1509476-25.2703018-35.3366852c0.0006771,0.4741631,0.0143661,30.1332989,0.0143661,33.7233963
            c0,1.083931-0.4242535,1.6252289-1.2727623,1.6252289l-15.7364731-0.026535
            c-0.9118103,0-1.3670421-0.4789429-1.3670421-1.4394875C0.13939,60.3709679,0,4.55264,0,1.0235707
            c0-0.6806062,0.612812-1.0215728,1.8384359-1.0215728c1.4908438,0,14.0697498,0.0192296,14.0697498,0.0192296
            s1.3576145-0.2193507,2.4207191,1.0542984c0,0,25.5432606,35.1244125,25.5145283,33.7941551
            c-0.0311966-1.444252-0.0417519-29.8692818-0.0417519-33.1515808C43.8016815,0.5731421,44.1316566,0,44.7916069,0
            c1.8855743,0,14.6881828,0.0039802,16.5737572,0.0039802C61.9620132,0.0039802,62.261013,0.484252,62.261013,1.443469z"
        />
        <path
            fill="#FFFFFF"
            d="M5.0117917,36.6889229l-1.291573-19.0357037c-0.2417307-3.708848-0.3625963-6.3724613-0.3625963-7.9880733
            c0-2.198451,0.5846512-3.9151254,1.7553589-5.1458702C6.2822838,3.2871466,7.8226147,2.671082,9.7325687,2.671082
            c2.311902,0,3.8578548,0.7877319,4.6392632,2.3645806c0.7800035,1.576848,1.1693029,3.8486729,1.1693029,6.8154736
            c0,1.7485161-0.0941629,3.5233355-0.2824879,5.32446l-1.7342777,19.5922375
            c-0.1883249,2.331356-0.5916786,4.120018-1.2100592,5.3659935C11.6945229,43.3784142,10.6727896,44.0014,9.2477016,44.0014
            c-1.4517899,0-2.460875-0.6022186-3.0258508-1.8080444S5.2535224,39.1531792,5.0117917,36.6889229z M9.4894323,62.8377495
            c-1.6401148,0-3.0722289-0.5233078-4.2963424-1.5699272c-1.2241135-1.0452347-1.8354676-2.5099449-1.8354676-4.3913651
            c0-1.6419144,0.5846512-3.0401726,1.7553589-4.1920052c1.1693025-1.1532173,2.6014166-1.7291374,4.2963433-1.7291374
            s3.1396885,0.5759201,4.3370991,1.7291374c1.1960058,1.1518326,1.7947111,2.5500908,1.7947111,4.1920052
            c0,1.8551178-0.6043272,3.3129044-1.8157921,4.3719826C12.5152836,62.307518,11.1042509,62.8377495,9.4894323,62.8377495z"
        />
    </BaseIcon>
);
